import Model from './Model'

class VirtualBankLineItem extends Model {
  constructor (initialData) {
    initialData.amount = Number(initialData.amount)
    initialData.balance = Number(initialData.balance)

    super(initialData, {
      momentKeys: [
        'created_at',
        'updated_at',
        'settled_at',
      ],
    })
  }

  get isDebit () {
    return this.amount < 0.0
  }

  get isCredit () {
    return this.amount >= 0.0
  }

  get isPaymentLineItem () {
    return this.type === 'VirtualBank::PaymentLineItem'
  }

  get isDistributionLineItem () {
    return this.type === 'VirtualBank::DistributionLineItem'
  }

  get isCreditLineItem () {
    return this.type === 'VirtualBank::CreditLineItem'
  }

  get isDebitLineItem () {
    return this.type === 'VirtualBank::DebitLineItem'
  }

  get isGsliLineItem () {
    return this.type === 'VirtualBank::GsliLineItem'
  }

  get isGsliTransferLineItem () {
    return this.type === 'VirtualBank::GsliTransferLineItem'
  }

  get isGsliRollbackTransferLineItem () {
    return this.type === 'VirtualBank::GsliRollbackTransferLineItem'
  }

  get isAgencyPayrollTransferLineItem () {
    return this.type === 'VirtualBank::AgencyPayrollTransferLineItem'
  }

  get isDkFeeRollbackTransferLineItem () {
    return this.type === 'VirtualBank::DkFeeRollbackTransferLineItem'
  }

  get isDkFeeTransferLineItem () {
    return this.type === 'VirtualBank::DkFeeTransferLineItem'
  }

  get isTransferLineItem () {
    return this.isGsliTransferLineItem || this.isDkFeeTransferLineItem
  }

  get isRollbackTransferLineItem () {
    return this.isGsliRollbackTransferLineItem || this.isDkFeeRollbackTransferLineItem
  }

  get isGsliItem () {
    return this.isGsliTransferLineItem || this.isGsliRollbackTransferLineItem
  }

  get isElectronicPaymentLineItem () {
    return this.type === 'VirtualBank::ElectronicPaymentLineItem'
  }

  get isElectronicRefundLineItem () {
    return this.type === 'VirtualBank::ElectronicRefundLineItem'
  }

  get isManualRefundLineItem () {
    return this.type === 'VirtualBank::ManualRefundLineItem'
  }

  get isAwaitingSettlement () {
    return this.aasm_state === 'awaiting_settlement'
  }

  get isSettled () {
    return this.aasm_state === 'settled'
  }

  get isFailed () {
    return this.aasm_state === 'failed'
  }

  get formattedDescription () {
    if (this.isGsliItem) {
      if (this.generic_sub_line_item.pay_schedule_entity_rule_id) {
        return `${this.generic_sub_line_item.assignment_user_full_name} — ${this.generic_sub_line_item.description}`
      } else {
        return this.descriptors_metadata.event_fee_description
      }
    } else if (this.isDebitLineItem) {
      return `Invoice ${this.descriptors_metadata.public_invoice_id} Sent`
    } else if (this.isElectronicPaymentLineItem) {
      const paymentMethod = this.formattedPaymentMethod
      const invoice = this.descriptors_metadata.public_invoice_id

      return `${paymentMethod} payment toward Invoice ${invoice}`
    } else if (this.isElectronicRefundLineItem) {
      return 'Electronic refund'
    } else {
      return this.description
    }
  }

  get formattedPaymentMethod () {
    switch (this.descriptors_metadata.payment_method_type) {
      case 'CreditCard':
        return 'Credit Card'
      case 'BankAccount':
        return 'ACH'
      default:
        return 'Unknown'
    }
  }
}

export default VirtualBankLineItem
